/* eslint-disable no-restricted-properties */
import window from 'window-or-global';

import { getLogger } from '@confluence/logger';

import messageHandlers from './message-handlers';

const logger = getLogger('LegacyMessageQueue');

const invokeMessageHandler = ({ type, payload }) =>
	new Promise((resolve, reject) => {
		logger.log`Received message ${{ type, payload }}`;
		if (!messageHandlers[type]) {
			return reject(new Error(`Received message in legacyMessageQueue of unknown type: ${type}`));
		}
		return resolve(messageHandlers[type](payload));
	});

export const initializeLegacyMessageQueue = () => {
	const { legacyMessageQueue } = window;
	let promiseChain = Promise.resolve();
	if (legacyMessageQueue && legacyMessageQueue.length > 0) {
		promiseChain = Promise.all(legacyMessageQueue.map(invokeMessageHandler));
	}
	return promiseChain.then(() => {
		window.legacyMessageQueue = {
			push: invokeMessageHandler,
		};
	});
};
